import { Phone, ArrowRight } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";
import { CONTACT } from "../data/content";

export const MobileBar = () => (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur-xl border-t border-hairline px-4 py-3 flex gap-3" data-testid="mobile-sticky-bar">
        <a
            data-testid="mobile-call-btn"
            href={CONTACT.phoneHref}
            className="flex-1 inline-flex items-center justify-center gap-2 border border-forest/25 text-forest font-semibold py-3 rounded-full text-sm"
        >
            <Phone size={16} strokeWidth={2.4} />
            Anrufen
        </a>
        <button
            data-testid="mobile-quote-btn"
            onClick={() => scrollToId("#angebot")}
            className="flex-[1.4] inline-flex items-center justify-center gap-2 bg-leaf text-white font-semibold py-3 rounded-full text-sm"
        >
            Angebot anfragen
            <ArrowRight size={16} strokeWidth={2.4} />
        </button>
    </div>
);
